import Model from 'ln/model/Model';
import { ChapterElement, Chapter } from '../chapter/Chapter';
import { QuizQuestion } from './QuizQuestion';
import { Summary } from './Summary';
import { ScormSingleton as scorm, suspendData, updateSuspendData } from '../../ScormSingleton';
import { setup } from '@lernetz/ts-lib/src/core/setup/Setup';
import { mapper } from '@lernetz/ts-lib/src/core/model/Mapper';


export class Quiz extends Model implements ChapterElement{

    public readonly chapter:Chapter;
    public readonly title:string;
    public estimated_time:number;
    public percent_to_pass:number;
    public questions:(QuizQuestion|Summary)[];
    public currentQuestion:(QuizQuestion|Summary);
    public currentIndex:number;
    public showQuiz:boolean;
    public canStartQuiz:boolean;
    public showSummary:boolean;
    public correctAnswers:number;
    public attempts:number;

    constructor(json: object) {
        super({
            chapter: null,
            title: '',
            estimated_time: null,
            percent_to_pass: null,
            questions: [],
            showQuiz: false,
            showSummary: false,
            canStartQuiz: true,
            currentQuestion: null,
            currentIndex:1,
            correctAnswers:0,
            attempts: 0,
            ...json,
        });

        this.currentQuestion = this.questions[0];
        this.injectQuiz();

        if( scorm.api.suspendData ){
            this.attempts = parseInt( scorm.api.suspendData );
        }

        
        
        this.evaluateCanStart();



    }

    public getViewName(): string {
        return 'Quiz';
    }

    public startQuiz(){
        // hackedihack: hide the elements from the overlay. 
        document.getElementById('master-close-button').classList.add('hidden');
        document.getElementById('closeChapter').classList.add('hidden');
        this.showQuiz = true;
    }

    public closeDetails(){
        document.getElementById('master-close-button').classList.remove('hidden');
        document.getElementById('closeChapter').classList.remove('hidden');
        this.resetQuiz();
    }

    public nextQuestion(){
        if( this.currentIndex < this.questions.length ){
            
            this.currentIndex++;
            this.currentQuestion = this.questions[this.currentIndex - 1];

        } else {

            let questions = this.questions as QuizQuestion[];

            // change questionCount
            this.showSummary = true;

            questions.forEach( question => { if( question.question.inputState == 'correct' ) this.correctAnswers++ });
            let percent = this.correctAnswers / this.questions.length * 100;

            let summary = new Summary({
                passed: ( percent >= this.percent_to_pass ) ? true : false,
                questions: this.questions,
                quiz: this
            });

            // update scorm
            scorm.api.completionStatus = 'completed';
            scorm.api.score = percent;
            scorm.api.successStatus = ( percent >= this.percent_to_pass ) ? 'passed' : 'failed';
            scorm.api.exit = 'normal';

            this.attempts++;
            suspendData.data.attempts = this.attempts;
            
            updateSuspendData();

            this.evaluateCanStart();

            this.currentQuestion = summary;
        
        }
      
    }

    public resetQuiz(){
        this.showQuiz = false;
        setup.route( 'quizData', { id: this.get( 'id' ) } ).load()
            .then( ( json ) => {
                this.questions = mapper.model( json );
                this.injectQuiz();
                this.currentIndex = 1;
                this.currentQuestion = this.questions[this.currentIndex - 1];
                this.correctAnswers = 0;
                this.showSummary = false;
                // shot the master-close-button
                document.querySelector('#body > main > div.content.-overlay > button').setAttribute('display', 'none');
            })
            .catch( ( error ) => console.log );
    }

    private injectQuiz(){
        this.questions.forEach( question => question.quiz = this );
    }

    private evaluateCanStart(){
        this.canStartQuiz = ( this.attempts < 3 );
    }

}